module.exports = __webpack_public_path__ + "img/g.3c152764.jpg";